// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"330f16c3","703":"451e100b","787":"e62bb527"}[chunkId] + ".chunk.js";
};